import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { notifyParent } from 'mailup-react-helpers'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  PageHeader
} from 'mailup-web-components'

import { saveCallback } from '../recoil/callbacks/callbacks'
import { pageState } from '../recoil/state/page'
import { isSaveBtnDisabled, sourceState } from '../recoil/state/source'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { idSource, name } = useRecoilValue(sourceState)
  const { loading } = useRecoilValue(pageState)
  const saveDisabled = useRecoilValue(isSaveBtnDisabled)
  const onClickSave = useRecoilCallback(saveCallback, [])

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      idSource > 0 ? 'ContentsSourcesUpdate' : 'ContentsSourcesCreate',
      redirectUrl
    ])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
      'data-mu-test': 'breadcrumb-item__sources',
      className: 'test-breadcrumb-item__sources',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    idSource > 0
      ? {
          label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
          'data-mu-test': 'breadcrumb-item__edit',
          className: 'test-breadcrumb-item__edit'
        }
      : {
          label: intl.formatMessage({ id: 'Load.NavMenu.Create' }),
          'data-mu-test': 'breadcrumb-item__new',
          className: 'test-breadcrumb-item__new'
        }
  ]

  const ControlsComponent = () => {
    return (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        onClick={onClickSave}
        disabled={saveDisabled}
        data-mu-test='button-save-header'
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
      </Button>
    )
  }

  return (
    <PageHeader
      loading={loading}
      breadcrumbsItems={breadcrumbsItems}
      ControlsComponent={ControlsComponent}
      title={
        idSource > 0 ? name : intl.formatMessage({ id: 'Load.NavMenu.Create' })
      }
    />
  )
}

export default Header
